import { Link } from "react-router-dom";
import { transactions } from "../api/client";
import { fmtEUR } from "../lib/auth";
import { useWidgetData } from "./data";
import type { WidgetComponentProps } from "./registry";

export default function UmsaetzeWidget({ config }: WidgetComponentProps) {
  const count = Number(config.count) || 5;
  const rows = useWidgetData(`tx:${count}`, () => transactions.list({ limit: count }));
  return (
    <section className="card p-5">
      <div className="flex items-baseline justify-between mb-3">
        <h2 className="section-title">Letzte Umsätze</h2>
        <Link to="/transactions" className="text-xs text-brand-300 hover:underline">
          Alle →
        </Link>
      </div>
      {!rows || rows.length === 0 ? (
        <p className="text-sm text-ink-400">Noch keine Umsätze.</p>
      ) : (
        <ul className="divide-y divide-ink-800">
          {rows.map((t) => {
            const amount = Number(t.amount);
            return (
              <li key={t.id} className="py-2 flex items-center gap-3 min-w-0">
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-ink-100 truncate">
                    {t.counterparty || t.description || "—"}
                  </div>
                  <div className="text-[11px] text-ink-500 num">{t.date}</div>
                </div>
                <span
                  className={
                    "num text-sm font-semibold shrink-0 " +
                    (amount >= 0 ? "text-good-500" : "text-ink-100")
                  }
                >
                  {amount >= 0 ? "+" : ""}
                  {fmtEUR(amount)}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
